import { useCallback, useState } from 'react'
import { useTranslation } from 'react-i18next'

import { deleteWashingMachinePartApi, getAllWashingMachinePartApi } from '@/apis/washingMachinePart'
import useNotification from '@/hooks/useNotification'
import { GetWashingMachinePartRequest } from '@/types/apis/washingMachinePart/GetWashingMachinePartRequest'
import { GetWashingMachinePartResponse } from '@/types/apis/washingMachinePart/GetWashingMachinePartResponse'

export type PageQueryParams = {
  page?: number
}

export const useWashingMachineParts = () => {
  const { t } = useTranslation()
  const openNotification = useNotification()
  const [getWashingMachinePartsLoading, setGetWashingMachinePartsLoading] = useState(false)
  const [getWashingMachinePartsResponse, setWashingMachinePartsResponse] = useState<GetWashingMachinePartResponse>()
  const [deleteWashingMachinePartLoading, setDeleteWashingMachinePartLoading] = useState(false)

  const getAllWashingMachinePart = useCallback(async () => {
    try {
      setGetWashingMachinePartsLoading(true)
      const res = await getAllWashingMachinePartApi()

      setWashingMachinePartsResponse(res)
    } finally {
      setGetWashingMachinePartsLoading(false)
    }
  }, [])

  const deleteWashingMachinePart = useCallback(
    async ({ id }: GetWashingMachinePartRequest) => {
      try {
        setDeleteWashingMachinePartLoading(true)
        await deleteWashingMachinePartApi({ id })
        openNotification({ type: 'success', description: t('components.pages.admins.common.delete.success') })
      } catch {
        openNotification({ type: 'error', description: t('components.pages.admins.common.delete.fail') })
      } finally {
        setDeleteWashingMachinePartLoading(false)
      }
    },
    [openNotification, t]
  )

  return {
    getWashingMachinePartsLoading,
    getWashingMachinePartsResponse,
    deleteWashingMachinePartLoading,
    getAllWashingMachinePart,
    deleteWashingMachinePart,
  }
}
